import {
  GET_USER_SERVICES_SUCCESS,
  PATCH_USER_SERVICES_SUCCESS
} from '../constants/services';

export default (state = [], action) => {
  switch (action.type) {
    case PATCH_USER_SERVICES_SUCCESS:
      let newServices = [...state];
      newServices = newServices.map((service) => {
        if (service.id === action.payload.service) {
          service.live_notifications = !service.live_notifications;
        }
        return service;
      });
      return [...newServices];

    case GET_USER_SERVICES_SUCCESS:
      return [...action.payload];

    default:
      return state;
  }
};
